"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var styled_components_1 = require("styled-components");
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        select: {
            height: '40px',
            minWidth: '120px',
            minHeight: '35px',
            borderColor: '#E6E7E8',
            '& .MuiOutlinedInput-input': {
                padding: '8px 32px 8px 12px'
            }
        },
        selectLabel: {
            color: '#4C566C',
            fontSize: '12px',
            marginBottom: '4px'
        }
    });
});
var DatasetsRadioButtons = function (_a) {
    var originalDatasets = _a.originalDatasets, datasetsValue = _a.datasetsValue, handleChange = _a.handleChange;
    var classes = useStyles();
    return ((0, jsx_runtime_1.jsxs)(SelectContainer, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ className: classes.selectLabel }, { children: "\u6307\u6A19" })), (0, jsx_runtime_1.jsx)(core_1.FormControl, { children: (0, jsx_runtime_1.jsxs)(core_1.Select, __assign({ variant: "outlined", className: classes.select, value: datasetsValue, onChange: handleChange }, { children: [(0, jsx_runtime_1.jsx)(core_1.MenuItem, __assign({ value: 'all' }, { children: "\u3059\u3079\u3066\u306E\u6307\u6A19" }), 'all'), originalDatasets.map(function (item) {
                            return ((0, jsx_runtime_1.jsx)(core_1.MenuItem, __assign({ value: item.id }, { children: item.label }), item.id));
                        })] })) })] }));
};
var SelectContainer = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 8px;\n"], ["\n  margin: 8px;\n"])));
exports["default"] = DatasetsRadioButtons;
var templateObject_1;
